export function getValueOrNull<T>(value: T | undefined | null): NonNullable<T> | null {
  return value ?? null
}

export function getValidPrimitiveFromSet<T>(arg: unknown, set: T[]): T | null {
  const match = set.find((x) => x === arg)
  return match ? match : null
}

/**
 * Useful alternative to .filter(Boolean) that is type safe
 */
export function isDefined<T>(value: T | null | undefined): value is NonNullable<T> {
  return typeof value !== 'undefined' && value !== null && value !== undefined
}
